import { Role } from '../types/role.type'

export class User {
  id: string
  email: string
  role: Role
  firstName: string
  lastName: string
  isDisabled: boolean
  acceptedTermsVersion?: string
  constructor(data: Partial<User>) {
    this.firstName = data.firstName ?? ''
    this.lastName = data.lastName ?? ''
    this.email = data.email ?? ''
    this.id = data.id ?? ''
    this.role = data.role ?? Role.USER
    this.isDisabled = data.isDisabled ?? false
    this.acceptedTermsVersion = data.acceptedTermsVersion ?? ''
  }
}
